export default __webpack_public_path__ + "static/media/order.e7472329.svg";